import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { faireDateRangeFromExpectedShipDateRange } from "@faire/web--source/common/expectedShipDateRange";
import { PresetDateFormat } from "@faire/web--source/common/FaireDateRange";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { ILeanProductTile as ILeanProductTileImport } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { LegacyIQuickAddConverter } from "@faire/retailer/components/QuickAdd/LegacyIQuickAddConverter";
import { DEFAULT_CURRENCY } from "@faire/retailer/consts/DEFAULT_CURRENCY";
import { transformBrandToLeanBrand, transformProductToOptionLessProduct } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/adapters";
import { getBestProductImage, getCaseSizeText, getLeastExpensiveOptionByRetailPrice, getProductLevelPromotion, getProductOptionRetailPrice, getProductOptionWholesalePrice } from "@faire/retailer/lib/product";
export var ILeanProductTileWithBrand;
(function(ILeanProductTileWithBrand) {
    ILeanProductTileWithBrand.build = function(partial) {
        return _object_spread({
            brand: ILeanProductTileImport.IBrand.build(partial === null || partial === void 0 ? void 0 : partial.brand)
        }, ILeanProductTileImport.build(partial));
    };
})(ILeanProductTileWithBrand || (ILeanProductTileWithBrand = {}));
export var ILeanProductTile;
(function(ILeanProductTile) {
    ILeanProductTile.from = function(product, strictLocalize) {
        var brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, badgeMap = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, promoString = arguments.length > 4 ? arguments[4] : void 0;
        var _getLeastExpensiveOptionByRetailPrice;
        var best_image = getBestProductImage(product);
        var dateRange = product ? faireDateRangeFromExpectedShipDateRange(product) : undefined;
        var minOptionWholesalePromoPrice = getProductLevelPromotion(product);
        var _product_token;
        return ILeanProductTileWithBrand.build({
            brand: !brand ? undefined : transformBrandToLeanBrand(brand),
            product: !product ? undefined : transformProductToOptionLessProduct(product),
            badge_list: IBadgeList.build(badgeMap[(_product_token = product === null || product === void 0 ? void 0 : product.token) !== null && _product_token !== void 0 ? _product_token : ""]),
            best_image: best_image,
            quick_add: product ? new LegacyIQuickAddConverter(product, strictLocalize).toIQuickAdd() : undefined,
            min_option_retail_price: product ? getProductOptionRetailPrice(product) : IFaireMoney.build({
                amount_cents: 0,
                currency: DEFAULT_CURRENCY
            }),
            min_option_wholesale_price: product ? getProductOptionWholesalePrice(product) : IFaireMoney.build({
                amount_cents: 0,
                currency: DEFAULT_CURRENCY
            }),
            expected_shipping_date: dateRange ? strictLocalize({
                id: "o0tz12",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ships "
                    },
                    {
                        type: 1,
                        value: "date"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                date: dateRange.format({
                    presetDateFormat: PresetDateFormat.ABBREVIATED_MMM_D
                })
            })) : undefined,
            min_option_wholesale_promo_price: minOptionWholesalePromoPrice,
            is_highlighted_product_for_promotional_event: product === null || product === void 0 ? void 0 : product.is_highlighted_product_for_promotional_event,
            case_size_text: product ? getCaseSizeText(product, strictLocalize) : undefined,
            min_option_brand_code: product ? (_getLeastExpensiveOptionByRetailPrice = getLeastExpensiveOptionByRetailPrice(product.options)) === null || _getLeastExpensiveOptionByRetailPrice === void 0 ? void 0 : _getLeastExpensiveOptionByRetailPrice.brand_code : undefined,
            has_active_brand_promo: !!(brand === null || brand === void 0 ? void 0 : brand.is_highlighted_brand_for_promotional_event),
            brand_promo_text: promoString,
            based_in_country: brand === null || brand === void 0 ? void 0 : brand.based_in
        });
    };
})(ILeanProductTile || (ILeanProductTile = {}));
